import { Loader } from '@googlemaps/js-api-loader';
import { Section } from './jobs-flow/Section';
import { CRUDFabric } from './CRUDs/CRUDFabric';
import { Customer }  from './CRUDs/entities/Customer';
import { SimpleSectionSwitcher } from './components/SimpleSectionSwitcher';
import { HasAttachments } from './CRUDs/abstracts/mixins/HasAttachments';

export default {
    dropzoneFiles: {},
    init() {
        this.mapInit();
        this.showJobChecklistModal();
        this.showMoreInfo();
        this.toggleViewAllPictures();
        this.changeJobStatus();
        this.viewWorkerCard();
        this.addWorkerComment();
        this.markJobsDone();
        this.saveChecklistJobsDone();
        this.initSection();
        this.initMobileBtns();
        this.loader_lib = false;
        HasAttachments.setAttachmentCallbackDelete();
        HasAttachments.setAttachmentCallbackPreview();
    },

    initMobileBtns(){
        // leave-comments
        $('.data-tables .more-info-container .leave-comments').off('click').on('click', (e) => {
            const entityType = $(e.currentTarget).data('type');
            const entityId = $(e.currentTarget).data('job-id');
            $('#leave-comments-modal').modal('show');
            $('#leave-comments-modal button.comment-button').data('job-id', entityId);
            $('#leave-comments-modal button.comment-button').data('type', entityType);
        });

        // upload files
        $('.data-tables .more-info-container .upload-file').off('click').on('click', (e) => {
            const entityType = $(e.currentTarget).data('type');
            const entityId = $(e.currentTarget).data('job-id');
            const entityClass = CRUDFabric.getClass(entityType);
            const entity = new entityClass(entityId);
            entity.openDropZone();
        });
    },

    mapInit() {
        if (this.checkCurrentPath()) {
            if($('meta[name="google-api-key"]').length){
                let _this = this;
                let googlApi = $('meta[name="google-api-key"]').attr('content');
                const apiOptions = {
                    apiKey: googlApi
                };
                const loader = new Loader(apiOptions);
                loader.load().then(() => {});
                /* let loader;
                import('@googlemaps/js-api-loader').then((module)=>{
                    this.loader_lib = module.Loader;
                }).then(()=>{
                    loader = new this.loader_lib(apiOptions)
                    loader.load().then(() => {

                    });

                }); */
            }
        }
    },
    showChangeStatusModal() {
        $('.status').click(function () {
            let data = {
                type: $(this).data('type'),
                job_id: $(this).data('job_id'),
            }
            $.ajax({
                type: 'POST',
                url: '/worker-cabinet/get-statuses-modal',
                data: data,
                success: function (response) {
                    $('#statuses_modal').html(response);
                    $('#statuses_modal').show();
                },
                error: function (response) {
                    console.log(response);
                }
            });
        });
        $('#statuses_modal').on('click', '.close', function () {
            $('#statuses_modal').hide();
        });
    },

    showJobChecklistModal() {
        $('.checklist_btn').click(function () {
            let data = {
                customer_id: $(this).data('customer_id'),
                job_id: $(this).data('job_id'),
                type: $(this).data('type'),
            }
            $.ajax({
                type: 'POST',
                url: '/worker-cabinet/get-checklist',
                data: data,
                success: function (response) {
                    $('#job_checklist_modal').html(response);
                    $('#job_checklist_modal').show();
                },
                error: function (response) {
                    console.log(response);
                }
            });
        });
        $('#job_checklist_modal').on('click', '.close', function () {
            $('#job_checklist_modal').hide();
        })
    },

    markJobsDone() {
        $(document).on('click','#job_checklist_modal .mark-as-done', function () {
            //text
            $(this).closest('.jobs-list').find('div,input,button').toggleClass('text-muted')
            //button
            $(this).closest('.mark-as-done').val() == "Done" ?
                $(this).closest('.mark-as-done').val('Mark as Done') :
                $(this).closest('.mark-as-done').val("Done")
            //info
            $(this).parent().children().first().val() == '1' ?
                $(this).parent().children().first().val('0') :
                $(this).parent().children().first().val('1')

        })
    },
    saveChecklistJobsDone() {
        $(document).on('click','#job_checklist_modal .save-view', function () {

            let jobMarks = $('.marked-done').serialize()
            let comment = $('.done-comment').val().trim()
            let job_id = $('.mark-as-done').data('job-id')
            let checklist_id = $('.mark-as-done').data('checklist-id')

            $.ajax({
                url: `/worker-cabinet/change-item-status`,
                type: "POST",
                data: {jobMarks, comment, checklist_id},
                headers: {
                    'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (data) {
                },
                error: function (msg) {
                }
            });
            $('#job_checklist_modal').hide()
            $(document).find('.modal-backdrop').last().remove()

        })
    },

    showMoreInfo() {
        $('#worker_cabinet').on('click', '.show_more_btn', function () {
            let id = $(this).data('id');
            let type = $(this).data('type');
            const svgOpenButton = $(this).find('svg.svg-open');
            const svgCloseButton = $(this).parent('td').find('svg.svg-close');
            if ($('.more-info-' + id + '[data-type='+type+']').hasClass('d-none')) {
                $('.more-info-' + id + '[data-type='+type+']').removeClass('d-none');

                svgCloseButton.addClass('d-flex').removeClass('d-none');
                svgOpenButton.addClass('d-none').removeClass('d-flex');

                $(this).find('.arrow').css('transform', 'rotate(225deg)');
                $(this).find('span').text('Close');
            } else {
                $('.more-info-' + id + '[data-type='+type+']').addClass('d-none');
                $(this).find('.arrow').css('transform', '');
                $(this).find('span').text('More');
                svgCloseButton.addClass('d-none').removeClass('d-flex');
                svgOpenButton.addClass('d-flex').removeClass('d-none');

            }
        });
    },


    addWorkerComment(){
        $(document).on('click', 'button.comment-button', function () {
            let jobId = $(this).data('job-id');
            let type = $(this).data('type');
            let commentText = $('#comment-textarea').val();
            const callback = (res) => {
                let messageClass = res.success ? '.text-success':'.text-danger'
                $(`#leave-comments-modal ${messageClass}`).text(res.message)
                $(`#leave-comments-modal ${messageClass}`).removeClass('d-none')
                if(res.success)
                    setTimeout(() => {
                        $(`#leave-comments-modal ${messageClass}`).addClass('d-none')
                        $('#leave-comments-modal').modal('hide');
                    }, 2500)
            }

            const entityClass = CRUDFabric.getClass(type);
            const entity = new entityClass(jobId);
            entity.addWorkerComment(commentText, callback);
        });
    },

    viewWorkerCard() {
        let _this = this;
        $('.modal-worker-jobs__open').click(function (e) {
            let element = $(this);
            let customerId = element.data('customer-id');
            let lat = parseFloat(element.data('customer-lat'));
            let lon = parseFloat(element.data('customer-lon'));
            $.ajax({
                url: '/worker-cabinet/viewWorkersCard/' + customerId,
                type: 'GET',
                success: function (res) {
                    $('#ajax_modals_container').html(res);
                    $('#customer-flyer').modal('show');
                    $('#customer-flyer').css('padding-right', 0);
                    if(lat && !isNaN(lat)&& lon && !isNaN(lon)){
                        _this.mapInit();
                        _this.RouteDisplayMap({
                            lat,
                            lon
                        });
                    }
                    _this.toggleViewAllPictures();

                    let switchers = document.querySelectorAll('#customer-flyer .switcher');
                    for(let sw of switchers){
                        new SimpleSectionSwitcher(sw)
                    }
                    _this.uploadListener(customerId);
                }
            });
        });
    },

    uploadListener(customerId) {
        if(customerId){
            const customer = new Customer(customerId)
            customer.scopeOpenDropZoneListener()
        }
    },

    toggleViewAllPictures() {
        $('.view-images-btn').on('click',function (e) {
            $(this).addClass('d-none')
            if($('#customer-flyer .view-all-images').hasClass('d-none')){
                $('#customer-flyer .images-header-img').addClass('d-none')
                $('#customer-flyer .other-info').addClass('d-none')
                $('#customer-flyer .view-all-images').removeClass('d-none')
                $('#customer-flyer .view-images-back-btn').removeClass('d-none')
            }
        });
        $('.view-images-back-btn').on('click',function (e) {
            $(this).addClass('d-none')
            if(!$('#customer-flyer .view-all-images').hasClass('d-none')){
                $('#customer-flyer .view-all-images').addClass('d-none')
                $('#customer-flyer .images-header-img').removeClass('d-none')
                $('#customer-flyer .other-info').removeClass('d-none')
                $('#customer-flyer .view-images-btn').removeClass('d-none')
            }
        });
    },


    changeJobStatus() {
        $('.job-status-change').off('change').on('change', function (ev) {
            const element = $(ev.currentTarget)
            const entity = element.data('entity')
            const status = Number(element.val())
            let data = {
                id: element.data('id'),
                type: entity,
                status,
            }
            const changeStatusEl = ev.currentTarget
            let opacity=0.5
            const fadeStatus = (r,g,b)=>{
                $(changeStatusEl).css('background-color',`rgba(${r},${g},${b},${opacity})`)
                opacity-=0.006;
                requestAnimationFrame(()=>fadeStatus(r,g,b))
                if(opacity<=0) return
            }
            $.ajax({
                type: 'POST',
                url: '/worker-cabinet/change-job-status',
                data: data,
                success: function (response) {
                    $(changeStatusEl).data('prev-status', $(changeStatusEl).val())
                    requestAnimationFrame(()=>fadeStatus(60,210,134))
                    const Entity = CRUDFabric.getClass(entity);
                    if(Entity?.statuses){
                        if(status == Entity.statuses?.COMPLETED || status == Entity.statuses?.CANCELED)
                            element.closest('.data-row').addClass('canceled')
                        else
                            element.closest('.data-row').removeClass('canceled')
                    }
                },
                error: function (response) {
                    $(changeStatusEl).val($(changeStatusEl).data('prev-status'))
                    requestAnimationFrame(()=>fadeStatus(219,58,87))
                }
            });
        });
    },

    RouteDisplayMap(latLonObj) {

        let route_map_center = new google.maps.LatLng(latLonObj.lat, latLonObj.lon);
        let mapCanvas = document.getElementById('route-map');
        let mapOptions = {
            zoom: 15,
            center: route_map_center,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            disableDefaultUI: false,
            scrollwheel: false,
            zoomControl: false,
            mapTypeControl: false,
            scaleControl: true,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            clickableIcons: false,
            styles: [{"featureType": "administrative", "elementType": "geometry", "stylers": [{"visibility": "off"}]},
                {"featureType": "poi", "stylers": [{"visibility": "off"}]},
                {"featureType": "road", "elementType": "labels.icon", "stylers": [{"visibility": "off"}]},
                {"featureType": "transit", "stylers": [{"visibility": "off"}]}]
        };

        let route_map = new google.maps.Map(mapCanvas, mapOptions);
        this.RouteMapAddMarkerOrder(latLonObj, route_map);
    },

    RouteMapAddMarkerOrder(latLonObj, map) {

        let marker = new google.maps.Marker({
            position: {
                lat: parseFloat(latLonObj.lat),
                lng: parseFloat(latLonObj.lon),
            },
            map: map,
        });
    },

    initSection() {
        if (window.location.pathname == '/worker-cabinet') {
            const section = new Section('workers-targets', true);
            section.show();
        }
    },

    /**
     * Проверка текущей страницы
     *
     * @returns bool [true|false]
     */
    checkCurrentPath(){
        let currentPath = window.location.pathname;
        const pathesArray = [
            '/worker-cabinet',
            '/customers',
            '/appointments',
            '/jobs-flow',
            '/events'
        ];
        let flag = false;
        pathesArray.forEach(element => {
            if (currentPath == element) {
                flag = true;
            }else if(currentPath.includes(element)){
                return true;
            }
        });
        return flag;
    }
}
